import styled from 'styled-components';
import {Color} from '../tokens/colors';
import {Radius} from '../tokens/radiuses';
import {Shadow} from '../tokens/shadows';

const StyledFormWrapper = styled.div`
    z-index: 2000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledForm = styled.div`
    width: 90%;
    max-width: 358px;
    background-color: ${Color.WHITE};
    border-radius: ${Radius.BLOCK};
    box-shadow: ${Shadow.BLOCK};
`;

const StyledFormBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 24px;
`;

export {StyledFormWrapper, StyledForm, StyledFormBody};
